var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        {
          staticClass: "loader",
          class: {
            "loader--backdrop": _vm.backdrop,
            "loader--sticky": _vm.sticky,
          },
        },
        [_vm._m(0)]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader__spinner" }, [
      _c("div", { staticClass: "loader__ring" }),
      _vm._v(" "),
      _c("div", { staticClass: "loader__ring" }),
      _vm._v(" "),
      _c("div", { staticClass: "loader__ring" }),
      _vm._v(" "),
      _c("div", { staticClass: "loader__ring" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }